<template>
    <div>
        <div class="col-12 row my-3">
            <a :href="return_route" class="mr-auto ml-2">
                <button class="btn btn-default float-right" type="button">{{ $lang('Wróć') }}</button>
            </a>
            <button type="button" class="btn btn-primary ml-auto mr-0"
                    data-toggle="modal" data-target="#new_alert">{{ $lang('Nowy alert') }}
            </button>
        </div>
        <new-alert-modal
            :url="create_route"
        ></new-alert-modal>

        <div class="form-row col-12">
            <draggable v-model="alertsArray" group="Alerty" @start="drag=true" @end="drag=false" class="col-12">
                <div v-for="alert in alertsArray" :class="'col-12 alert alert-'+alert.type">
                    <div class="row">
                        <span class="ml-3 font-weight-bold">{{ alert.header }}</span>
                        <i class="fa fa-pencil tile  fa-lg print ml-auto mr-2" aria-hidden="true"
                           data-toggle="modal" data-target="#edit_alert" @click="editedAlert=alert"></i>
                        <i class="fa fa-trash tile  fa-lg print mr-4" @click="deleteAlert(alert.id)"
                           aria-hidden="true"></i>
                    </div>
                    <hr class="colorgraph">
                    <div style="white-space: pre-wrap">{{ alert.content }}</div>
                </div>
            </draggable>
        </div>

        <edit-alert-modal
            :url="update_route"
            :alert=editedAlert
        ></edit-alert-modal>
    </div>
</template>

<script>
import EditAlertModal from "./edit-alert-modal";
import NewAlertModal from "./new-alert-modal";
import Draggable from 'vuedraggable'
import ShowNotification from "../../mixins/show-notification";

export default {
    mixins: [ShowNotification],
    name: "alerts-index",
    components: {EditAlertModal, NewAlertModal, Draggable},
    props: {
        return_route: String,
        alerts: Array,
        create_route: String,
        update_route: String,
        delete_route: String,
        order_route: String,
    },
    data() {
        return {
            editedAlert: null,
            alertsArray: this.alerts
        }
    },
    watch: {
        alertsArray: {
            deep: true,
            handler() {
                this.saveOrder();
            }
        }
    },
    methods: {
        deleteAlert(id) {
            axios.post(this.delete_route, {
                id: id
            })
                .then(function () {
                    location.reload();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        saveOrder() {
            const self = this;
            axios.post(this.order_route, {
                array: this.alertsArray
            })
                .catch(function (error) {
                    console.log(error)
                });
        }
    }
}
</script>
